module.exports = __webpack_public_path__ + "static/media/details-8-image-1.da2422ae.jpg";